/**
 * True when the start calendar day is after the user's local calendar day.
 * Reads the `yyyy-MM-dd` prefix only, so a midnight value does not shift a day.
 * Does not look at end date or status text.
 */
export function isFutureClientProductStart(start?: string | null, today: Date = new Date()): boolean {
  const startDay = /^\d{4}-\d{2}-\d{2}/.exec(start?.trim() ?? '')?.[0];
  if (!startDay) {
    return false;
  }
  const todayDay = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
  return startDay > todayDay;
}
